import React from 'react';
import {
  Alert,
  AlertProps,
  AlertTitle,
  Snackbar,
  SnackbarProps,
} from '@mui/material';

type NotificationProps = Omit<SnackbarProps, 'children'> & {
  open: boolean;
  type?: AlertProps['severity'];
  children?: React.ReactNode;
  title?: AlertProps['title'];
};

const NOTIFICATION_DURATION = 6000;

/**
 * @deprecated Используй /shared/lib/useNotifications
 */
export const Notification = ({
  open,
  children,
  onClose: handleClose,
  type = 'error',
  title,
  ...otherProps
}: NotificationProps) => {
  return open ? (
    <Snackbar
      open={open}
      autoHideDuration={NOTIFICATION_DURATION}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      onClose={handleClose}
      {...otherProps}
    >
      <Alert severity={type} sx={{ width: '100%' }}>
        {title ? <AlertTitle>{title}</AlertTitle> : null}
        {children}
      </Alert>
    </Snackbar>
  ) : null;
};
